import { Input } from "../ui/input";
import { useLang } from "../../lib/i18n";

const FIELDS = [["name", "inv_name", true], ["vat_number", "inv_vat"], ["id_card", "inv_id"], ["address", "inv_address", true, true], ["city", "inv_city", true],
  ["zip", "inv_zip", true], ["country", "inv_country", true], ["email", "inv_email", true], ["phone", "inv_phone"], ["notes", "inv_notes", false, true]];

const Choice = ({ on, onClick, children, testid }) => (
  <button type="button" onClick={onClick} data-testid={testid}
    className={`flex-1 rounded-2xl border-2 px-3 py-2 text-sm font-semibold transition-colors ${on ? "border-[#FF5722] bg-orange-50 text-[#0A2540]" : "border-slate-200 text-slate-500"}`}>{children}</button>
);

export const invoiceValid = (b) => !b.invoice || b.mode === "parent" || FIELDS.every(([k, , req]) => !req || (b.data?.[k] || "").trim());

export const InvoiceBox = ({ value, onChange, parent }) => {
  const { t } = useLang();
  const set = (k, v) => onChange({ ...value, data: { ...(value.data || {}), [k]: v } });
  return (
    <div className="space-y-4 rounded-3xl border border-slate-200 bg-white p-6" data-testid="invoice-box">
      <p className="font-semibold text-[#0A2540]">{t("inv_q")}</p>
      <div className="flex gap-2">
        <Choice on={value.invoice} onClick={() => onChange({ ...value, invoice: true })} testid="invoice-yes">{t("inv_yes")}</Choice>
        <Choice on={!value.invoice} onClick={() => onChange({ ...value, invoice: false })} testid="invoice-no">{t("inv_no")}</Choice>
      </div>
      {value.invoice && <>
        <p className="text-sm font-semibold text-[#0A2540]">{t("inv_same_q")}</p>
        <div className="rounded-2xl bg-slate-50 p-3 text-xs text-slate-600" data-testid="invoice-parent-data">
          <b className="text-[#0A2540]">{parent.name}</b>{parent.id_card && ` · ${t("inv_id")}: ${parent.id_card}`}<br />
          {[parent.address, [parent.zip, parent.city].filter(Boolean).join(" "), parent.country].filter(Boolean).join(", ")}<br />{[parent.email, parent.phone].filter(Boolean).join(" · ")}
        </div>
        <div className="flex gap-2">
          <Choice on={value.mode !== "other"} onClick={() => onChange({ ...value, mode: "parent" })} testid="invoice-same">{t("inv_same")}</Choice>
          <Choice on={value.mode === "other"} onClick={() => onChange({ ...value, mode: "other" })} testid="invoice-other">{t("inv_other")}</Choice>
        </div>
        {value.mode === "other" && (
          <div className="grid grid-cols-2 gap-2" data-testid="invoice-other-form">
            {FIELDS.map(([k, l, req, full]) => (
              <Input key={k} placeholder={`${t(l)}${req ? " *" : ""}`} value={value.data?.[k] || ""} onChange={(e) => set(k, e.target.value)}
                className={`h-10 rounded-xl ${full || k === "name" ? "col-span-2" : ""}`} data-testid={`invoice-${k.replace("_", "-")}`} />))}
          </div>
        )}
        <p className="text-xs text-slate-500">{t("inv_saved_note")}</p>
      </>}
    </div>
  );
};
